import { Callout as Base } from "@corca/tiptap";

import { LineWrapperView } from "./utils/LineWrapperView";

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    callout: {
      toggleCallout: () => ReturnType;
      unsetCallout: () => ReturnType;
      setCallout: () => ReturnType;
      setCalloutColor: (color: string) => ReturnType;
    };
  }
}

export const Callout = Base.extend({
  addNodeView() {
    return (props) => {
      return new LineWrapperView(props, {
        renderNodeAsChildIn: ["listItem", "taskItem", "blockquote", "tableCell", "tableHeader"],
      });
    };
  },

  addCommands() {
    return {
      ...this.parent?.(),
      toggleCallout:
        () =>
        ({ commands }) => {
          return commands.toggleWrap(this.name);
        },
      unsetCallout:
        () =>
        ({ commands }) => {
          return commands.lift(this.name);
        },
      setCallout:
        () =>
        ({ commands }) => {
          return commands.wrapIn(this.name);
        },
    };
  },
});
